// Minutes as a phrase a person can read across a hall.
//
// THE INPUT IS ALREADY A COUNT OF MINUTES. operatorView decides how old a
// device is. This file only chooses the words, so a day-old tablet does not
// show up as "2592 minutes" on the one list somebody reads at 10:40.

/**
 * A span of minutes, in the smallest set of units that stays readable.
 *
 * Under an hour stays in minutes. An hour or more is hours and leftover
 * minutes. A day or more is days, then hours, then minutes. Zero leftover
 * units are dropped, so 120 minutes is "2 hours" rather than "2 hours 0 minutes".
 */
export function durationWords(minutes: number): string {
  if (!Number.isFinite(minutes) || minutes < 1) return "under a minute";

  const total = Math.floor(minutes);
  const days = Math.floor(total / 1_440);
  const hours = Math.floor((total % 1_440) / 60);
  const leftover = total % 60;
  const parts: string[] = [];

  if (days > 0) parts.push(countWord(days, "day"));
  if (hours > 0) parts.push(countWord(hours, "hour"));
  if (leftover > 0 || parts.length === 0) parts.push(countWord(leftover, "minute"));
  return parts.join(" ");
}

function countWord(count: number, unit: "day" | "hour" | "minute"): string {
  return count === 1 ? `1 ${unit}` : `${count} ${unit}s`;
}
